export default __webpack_public_path__ + "static/media/so.286b8ce2.jpg";